define([
    "jquery",
    "underscore",
    "marionette",
    "jquery.fileupload",
    "jquery.iframe-transport"
], function($, _, Marionette) {
    return Marionette.Behavior.extend({
        initialize: function(){
            $(document).bind('drop dragover', function (e) {
                e.preventDefault();
            });
        },

        onInitFileUpload: function(config){
            var $selector = config.$selector, type = config.type;

            var that = this;
            $selector.fileupload({
                url: config.url || config.baseUrl+type,
                dataType: 'json',
                dropZone: that.ui[type+'Name'],
                // File selected, put the original name in the textbox
                add: function(e, data){
                    HoldOn.open({
                        theme:"sk-fading-circle"
                    });

                    that.triggerMethod('hide:error', type);

                    data.submit();
                },
                // Upload success, put the server-side name in the hidden input
                done: function(e, data){
                    that.ui[type+'Name'].val(data.files[0].name);
                    that.ui[type].val(data.jqXHR.responseJSON.file_path);

                    HoldOn.close();
                },
                // Upload failed, display error + remove name from textbox
                fail: function(e,data){
                    var errors = {};
                    errors[type] = data.jqXHR.responseJSON.error_msg;

                    that.ui[type+'Name'].val('');
                    that.ui[type].val('');

                    that.triggerMethod('show:errors', errors, false);

                    HoldOn.close();
                }
            });
        }
    });
});
